// extracted by mini-css-extract-plugin
export default {"main":"PetAdoption_main__9Y7FL","formDiv":"PetAdoption_formDiv__t3dwU","form":"PetAdoption_form__gmKSn","input":"PetAdoption_input__E6eXu","select":"PetAdoption_select__kXNb5"};